import { render } from "./B2bPageCoacsu.vue?vue&type=template&id=0b33a785&scoped=true&lang=pug"
import script from "./B2bPageCoacsu.vue?vue&type=script&lang=js"
export * from "./B2bPageCoacsu.vue?vue&type=script&lang=js"

import "./B2bPageCoacsu.vue?vue&type=style&index=0&id=0b33a785&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b33a785"]])

export default __exports__